import * as React from 'react';
import { motion, MotionProps } from 'framer-motion';

export interface IAnimationElementProps extends MotionProps {
  children?: React.ReactNode;
  className?: string;
  key?: React.Key;
  id?: string;
}

export const AnimationElement = ({ children, ...animation }: IAnimationElementProps) => (
  <motion.div {...animation}>{children}</motion.div>
);
